/* eslint-disable camelcase */
// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

// app modules: props
import RecipeImageProps from 'components/RecipeImage/RecipeImageProps';

// app modules: services
import assets from 'services/assets';
import { getImageSrc, getImageSrcSet } from 'services/image';

// assets
import CssCollectionImage from './CollectionImage.scss';

class CollectionImage extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    bookCoverWidth: PropTypes.number,
    bookCoverHeight: PropTypes.number,
    overrideImage: PropTypes.string,
    contentImage: PropTypes.shape({
      book: PropTypes.shape({
        image_name: PropTypes.string,
        image_permission: PropTypes.bool,
      }),
      graphics: RecipeImageProps.graphics,
      instagram: PropTypes.string,
    }),
    mobileAsThumbnail: PropTypes.bool,
    iconImage: PropTypes.node,
    theme: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    width: 322,
    height: 322,
    bookCoverWidth: 240,
    bookCoverHeight: 240,
    alt: '',
    overrideImage: null,
    contentImage: null,
    mobileAsThumbnail: false,
    iconImage: null,
    theme: null,
  };

  renderImage() {
    const {
      width,
      height,
      bookCoverWidth,
      bookCoverHeight,
      contentImage,
      overrideImage,
      alt,
      mobileAsThumbnail,
    } = this.props;
    const coverImageContent = contentImage || {
      book: {
        image_permission: false,
      },
      graphics: [],
      instagram_url: null,
    };

    const imageOptions = {
      width,
      height,
      smart: true,
    };
    const imageSetOptions = [
      { w: imageOptions.width, h: imageOptions.height },
      { w: imageOptions.width * 2, h: imageOptions.height * 2 },
    ];
    // Try to use the custom image first
    let imageSrc;
    let imageSrcSet;
    if (overrideImage) {
      const url = overrideImage.startsWith('/') ? overrideImage : `covers/${overrideImage}`;
      imageSrc = assets.collectionUrl(url, imageOptions);
      imageSrcSet = assets.srcSet(url, imageSetOptions, assets.collectionUrl);
    } else if (coverImageContent.primary_image) {
      imageSrc =
        getImageSrc(coverImageContent.primary_image, 'square', size => size.w >= width) ||
        getImageSrc(coverImageContent.primary_image, 'square', size => size.w >= width / 2);
      imageSrcSet = getImageSrcSet(coverImageContent.primary_image, 'square', [
        { x: 1, w: width },
        { x: 2, w: width * 2 },
      ]);
    }
    if (imageSrc) {
      return (
        <img
          className={classNames('collection-image__image', {
            'collection-image--mobile-thumbnail__image': mobileAsThumbnail,
          })}
          src={imageSrc}
          srcSet={imageSrcSet}
          alt={alt}
          loading="lazy"
        />
      );
    }

    // If there isn't a content image, use the book cover.
    const imageFromBook = coverImageContent.book ? coverImageContent.book.image_name : null;
    if (imageFromBook) {
      const fallbackSrc = assets.coverUrl(imageFromBook, {
        resize: 'fit-in',
        width: bookCoverWidth,
        height: bookCoverHeight,
      });
      const fallbackSrcSet = assets.srcSet(
        imageFromBook,
        [
          { w: bookCoverWidth, h: bookCoverHeight, resize: 'fit-in' },
          { w: bookCoverWidth * 2, h: bookCoverHeight * 2, resize: 'fit-in' },
        ],
        assets.coverUrl,
      );

      if (fallbackSrc)
        return (
          <img
            className={classNames(
              'collection-image__image',
              'collection-image__image--book-cover',
              {
                'collection-image--mobile-thumbnail__image': mobileAsThumbnail,
              },
              {
                'collection-item--mobile-thumbnail__image--book-cover': mobileAsThumbnail,
              },
            )}
            src={fallbackSrc}
            srcSet={fallbackSrcSet}
            alt={alt}
          />
        );
    }

    // The fallback failed too - use a generic placeholder
    return (
      <img
        className={classNames(
          'collection-image__image',
          'collection-image__image--placeholder',
          {
            'collection-image--mobile-thumbnail__image': mobileAsThumbnail,
          },
          {
            'collection-item--mobile-thumbnail__image--placeholder': mobileAsThumbnail,
          },
        )}
        src="/images/logo-white.png"
        alt={alt}
      />
    );
  }

  render() {
    const { className, mobileAsThumbnail, iconImage, theme } = this.props;
    return (
      <figure
        className={classNames(className, 'collection-image__figure', {
          'collection-image--mobile-thumbnail__figure': mobileAsThumbnail,
          [`collection-image__figure--${theme}`]: theme,
        })}
      >
        {iconImage ? (
          <div className="collection-image__image collection-image__image--placeholder">
            {iconImage}
          </div>
        ) : (
          this.renderImage()
        )}
      </figure>
    );
  }
}
export default withStyles(CssCollectionImage)(CollectionImage);
